import React from 'react';
import './Pages.css';

export default function About() {
  return (
    <main className="page-content">
      <section className="page-hero">
        <div className="container">
          <h1>About Us</h1>
          <p>Learn more about our mission and team</p>
        </div>
      </section>

      <section className="container page-section">
        <h2>Our Mission</h2>
        <p>To empower businesses with innovative solutions that drive growth, enhance efficiency, and create lasting value. We believe in building partnerships with our clients based on trust, transparency, and a commitment to excellence.</p>
      </section>

      <section className="values-section">
        <div className="container">
          <h2>Our Values</h2>
          <div className="values-grid">
            <div className="value-card">
              <h3>Innovation</h3>
              <p>We constantly push boundaries and embrace new technologies.</p>
            </div>
            <div className="value-card">
              <h3>Integrity</h3>
              <p>Honesty and accountability are at the core of everything we do.</p>
            </div>
            <div className="value-card">
              <h3>Excellence</h3>
              <p>We strive for the highest quality in every project.</p>
            </div>
            <div className="value-card">
              <h3>Collaboration</h3>
              <p>We work closely with our clients to achieve shared goals.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="container page-section">
        <h2>Meet Our Team</h2>
        <div className="team-grid">
          <div className="team-member">
            <div className="member-image"></div>
            <h3>Sarah Johnson</h3>
            <p className="role">Founder & CEO</p>
            <p>Strategic visionary with 15+ years of industry experience</p>
          </div>
          <div className="team-member">
            <div className="member-image"></div>
            <h3>Michael Chen</h3>
            <p className="role">Lead Architect</p>
            <p>Expert in enterprise solutions and system design</p>
          </div>
          <div className="team-member">
            <div className="member-image"></div>
            <h3>Emma Rodriguez</h3>
            <p className="role">Creative Director</p>
            <p>Award-winning designer known for innovative experiences</p>
          </div>
        </div>
      </section>
    </main>
  );
}
